import {
  SignatureRequest,
  Signer,
  SignerStatus
} from "@wingspanhq/wingspan-api-sdk";

// v1 signed-documents used a fixed Payer/Payee `SignerRole` enum; v3 keeps
// free-form role strings on requirement-backed signature requests.
// TODO(v3-verify): confirm the role spellings on v3-provisioned requests.
export const PAYEE_SIGNER_ROLE = "Payee";
export const PAYER_SIGNER_ROLE = "Payer";

export const getSignerByRole = (
  signatureRequest: SignatureRequest | undefined,
  role: string
): Signer | undefined =>
  signatureRequest?.signers?.find(signer => signer.role === role);

export const getIsSignedByRole = (
  signatureRequest: SignatureRequest | undefined,
  role: string
): boolean => {
  const signer = getSignerByRole(signatureRequest, role);

  if (signer) {
    return signer.status === SignerStatus.SIGNED;
  }

  // role conventions unverified — degrade to "any signer signed"
  return !!signatureRequest?.signers?.some(
    ({ status }) => status === SignerStatus.SIGNED
  );
};

/** Whether the request includes a payer countersignature step. */
export const getHasPayerSigner = (
  signatureRequest: SignatureRequest | undefined
): boolean =>
  !!getSignerByRole(signatureRequest, PAYER_SIGNER_ROLE) ||
  (signatureRequest?.signers?.length ?? 0) > 1;
